import ApiService from "@/common/api.service";

const PATH = "stock/receiving-sessions";

export const START_STOCK_RECEIVING_SESSION = "startStockReceivingSession";
export const GET_STOCK_RECEIVING_SESSION = "getStockReceivingSession";
export const GET_STOCK_RECEIVING_SESSION_CONTEXT = "getStockReceivingSessionContext";
export const GET_STOCK_RECEIVING_SESSION_PRODUCT_LINES = "getStockReceivingSessionProductLines";
export const ACCEPT_STOCK_RECEIVING_LOT_ENTRY = "acceptStockReceivingLotEntry";
export const REMOVE_STOCK_RECEIVING_LOT_ENTRY = "removeStockReceivingLotEntry";
export const FINALIZE_STOCK_RECEIVING_SESSION = "finalizeStockReceivingSession";

const actions = {
  [START_STOCK_RECEIVING_SESSION](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_RECEIVING_SESSION](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_RECEIVING_SESSION_CONTEXT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${PATH}/${id}/context`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_RECEIVING_SESSION_PRODUCT_LINES](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${PATH}/${payload.receiptId}/products/${payload.productId}/delivery-note-lines`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [ACCEPT_STOCK_RECEIVING_LOT_ENTRY](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.receiptId}/lot-entries`, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [FINALIZE_STOCK_RECEIVING_SESSION](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/finalize`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [REMOVE_STOCK_RECEIVING_LOT_ENTRY](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${payload.receiptId}/lot-entries/${payload.sessionLotEntryKey}`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  actions,
};
